"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolGroupManagedBy = exports.SchoolGroupType = void 0;
var SchoolGroupType;
(function (SchoolGroupType) {
    SchoolGroupType["mat"] = "MAT";
})(SchoolGroupType = exports.SchoolGroupType || (exports.SchoolGroupType = {}));
var SchoolGroupManagedBy;
(function (SchoolGroupManagedBy) {
    SchoolGroupManagedBy["Sync"] = "sync";
})(SchoolGroupManagedBy = exports.SchoolGroupManagedBy || (exports.SchoolGroupManagedBy = {}));
//# sourceMappingURL=SchoolGroup.js.map